module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst meta = (model.documentData || {}).meta || {}\nconst document = meta.document || {}\nconst vat           = utils.number.format((document.vat || 0) * 100, { decimals: 0}, 'float').formatted\nconst sumNetPrice   = utils.number.format((document.sumNetPrice || 0) * -1, { decimals: 2}, 'float').formatted\nconst sumPrice      = utils.number.format((document.sumPrice || 0) * -1, { decimals: 2}, 'float').formatted\nconst sumVat        = utils.number.format(((document.sumPrice || 0) - (document.sumNetPrice || 0)) * -1, { decimals: 2}, 'float').formatted\nconst gracePeriod   = document.gracePeriod || 7\n%><div>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<tbody>\n<tr class=\"netPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div><%= sumNetPrice %></div></td>\n</tr>\n<tr class=\"vatPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\"><%- storage.__('document.creditNote.vat', { value: vat }) %></td>\n<td class=\"amount\"><div><%= sumVat %></div></td>\n</tr>\n<tr class=\"sum\">\n<td class=\"title\"><%- storage.__('document.creditNote.sum') %></td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div><%= sumPrice %></div></td>\n</tr>\n</tbody>\n</table>\n<div class=\"paymentInformation\">\n<%- String(model.paymentInformation).replace('{{gracePeriod}}', gracePeriod) %>\n</div>\n</div>"
  , __filename = "components/templates/core/documents/creditNote/summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const meta = (model.documentData || {}).meta || {}
const document = meta.document || {}
const vat           = utils.number.format((document.vat || 0) * 100, { decimals: 0}, 'float').formatted
const sumNetPrice   = utils.number.format((document.sumNetPrice || 0) * -1, { decimals: 2}, 'float').formatted
const sumPrice      = utils.number.format((document.sumPrice || 0) * -1, { decimals: 2}, 'float').formatted
const sumVat        = utils.number.format(((document.sumPrice || 0) - (document.sumNetPrice || 0)) * -1, { decimals: 2}, 'float').formatted
const gracePeriod   = document.gracePeriod || 7

    ; __line = 9
    ; __append("<div>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<tbody>\n<tr class=\"netPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div>")
    ; __line = 15
    ; __append(escapeFn( sumNetPrice ))
    ; __append("</div></td>\n</tr>\n<tr class=\"vatPrice\">\n<td class=\"title\">&nbsp;</td>\n<td class=\"vat\">")
    ; __line = 19
    ; __append( storage.__('document.creditNote.vat', { value: vat }) )
    ; __append("</td>\n<td class=\"amount\"><div>")
    ; __line = 20
    ; __append(escapeFn( sumVat ))
    ; __append("</div></td>\n</tr>\n<tr class=\"sum\">\n<td class=\"title\">")
    ; __line = 23
    ; __append( storage.__('document.creditNote.sum') )
    ; __append("</td>\n<td class=\"vat\">&nbsp;</td>\n<td class=\"amount\"><div>")
    ; __line = 25
    ; __append(escapeFn( sumPrice ))
    ; __append("</div></td>\n</tr>\n</tbody>\n</table>\n<div class=\"paymentInformation\">\n")
    ; __line = 30
    ; __append( String(model.paymentInformation).replace('{{gracePeriod}}', gracePeriod) )
    ; __append("\n</div>\n</div>")
    ; __line = 32
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/creditNote/summary.ejs

}